import { CenterScreen } from '@ztechapps/webui.util'

// Terminal state for a rejected preview-chunk import — renders instead of
// hanging on the Suspense fallback forever.
export const BlogPreviewChunkFailed = () => (
  <CenterScreen>
    <p>Preview is temporarily unavailable. Please try again later.</p>
  </CenterScreen>
)
